import { lazy, Suspense } from 'react';
import { Loader2 } from 'lucide-react';
import { IterpecHotel } from '@/types/iterpec';

// Lazy load the heavy Mapbox component
const HotelsMapModal = lazy(() => import('./HotelsMapModal'));

interface LazyHotelsMapModalProps {
  isOpen: boolean;
  onClose: () => void;
  hotels: IterpecHotel[];
  checkIn?: string;
  checkOut?: string;
  adults?: number;
  childrenAges?: number[];
}

const MapLoader = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
    <div className="flex flex-col items-center gap-3">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <span className="text-sm text-muted-foreground">Cargando mapa...</span>
    </div>
  </div>
);

export const LazyHotelsMapModal = ({ isOpen, ...props }: LazyHotelsMapModalProps) => {
  // Only render the heavy component when the modal is open
  if (!isOpen) return null;
  
  return (
    <Suspense fallback={<MapLoader />}>
      <HotelsMapModal isOpen={isOpen} {...props} />
    </Suspense>
  );
};

export default LazyHotelsMapModal;
